/**
 * @generated SignedSource<<47887d529a216b2a14f69f32e2c0a243>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "Portfolio",
    "kind": "LinkedField",
    "name": "addPortfolio",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "uuid",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AddPortfolioMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AddPortfolioMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "87f688c1a54a584f7c4bc80047d354ea",
    "id": null,
    "metadata": {},
    "name": "AddPortfolioMutation",
    "operationKind": "mutation",
    "text": "mutation AddPortfolioMutation(\n  $input: AddPortfolioInput!\n) {\n  addPortfolio(input: $input) {\n    id\n    uuid\n  }\n}\n"
  }
};
})();

node.hash = "af936f5b7da69b2b338f66bb67579ea1";

module.exports = node;
